export default __webpack_public_path__ + "static/media/metamask_icon.4c0cbc6d.png";